const addHttpFormat = (url: string): string => {
  if (url.startsWith('http')) {
    return url;
  }
  return `https://${url}`;
};

export default addHttpFormat;
